// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a1297182073c035c7797b771c4879010465524f1.chunk.js";
};